module.exports = __webpack_public_path__ + "static/grazzt-218107ca96bdc529baf79351d6583d84.png";